export default __webpack_public_path__ + "images/1a32440b10d528b1e98d9d140740dd09-list_icon.svg";